export default "__VITE_ASSET__EqXq7A2n__"